import {
  useSizeOptions,
  useNostoAppState,
} from "@nosto/search-js/preact/hooks";
import { pick } from "@nosto/search-js/utils";
import { defaultSize, sizes } from "@/config";
import Pagination from "@/components/Pagination/Pagination";

export default function BottomToolbar() {
  const { loading } = useNostoAppState((state) => pick(state, "loading"));
  const { from, to, total } = useSizeOptions(sizes, defaultSize);

  return (
    <div className="plp__pagination">
      <Pagination />
      {!loading && (
        <div className="plp__pagination-text" data-nosto-element="totalResults">
          Showing {from + 1} - {total < to ? total : to} of {total}
        </div>
      )}
    </div>
  );
}
